module.exports = { 
      attributes: {"title":"Hausliga 3. Runde","date":"2019-08-24T00:00:00.000Z","author":"Richard","categories":["news"],"tags":["news"],"language":"de","section":null},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = function render() { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0) };
            this.$options.staticRenderFns = [function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markdown-body"},[_c('p',[_vm._v("Die 3. Runde der Hausliga wurde erfolgreich durchgeführt,\nin einer etwas kleineren Runde aber trotzdem spannend.\nFumihiro zeigt sein beständiges Spiel und konnte seine Punkte weiter ausbauen,\ndamit holte er sich die Führung.\nEs waren 3 Spieler mit gleicher Anzahl an Punkten an diesem Abend,\nsomit erhöht sich das Handicap für den stärksten Spieler Kei.\nFür Richi lief es diesmal überhaupt nicht und er verlor alle seine Partien\nund verliert somit seinen erhöhten Handicap.\nTokuwei scheint seine Pechsträhne abgeschüttelt zu haben und gewinnt erst mal Punkt hinzu.\nIst das nun der Beginn seiner Aufholjagd?")]),_vm._v(" "),_c('p',[_vm._v("Die Ergebnisse zur 3. Hausliga findet ihr "),_c('a',{attrs:{"href":"#/shogi/internalgames201908"}},[_vm._v("hier")]),_vm._v(".")])]) }];
          }
        }
      },
     }